import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type FieldDefinitionInfoFragment = { __typename?: 'ProjectFieldDefinition', id: string, fieldType: Types.FieldTypeEnum, isSystemField: boolean, isSortable?: boolean | null, name: string };

export const FieldDefinitionInfo = /*#__PURE__*/ gql`
    fragment FieldDefinitionInfo on ProjectFieldDefinition {
  id
  fieldType
  isSystemField
  isSortable
  name
}
    ` as unknown as DocumentNode<FieldDefinitionInfoFragment, unknown>;

        

        
export const useFieldDefinitionInfoFragment = (
  input: string | Omit<UseFragmentOptions<FieldDefinitionInfoFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'ProjectFieldDefinition' } };
    return input;
  })();

  return useFragment<FieldDefinitionInfoFragment>({
    fragment: FieldDefinitionInfo,
    fragmentName: 'FieldDefinitionInfo',
    ...options,
  });
};
  
        